<template>
  <div class="body-container home">
    <div class="background-image-container">
      <div class="hor-half">
        <div class="hor-65">
          <div class="animated-background height-50" :style="{'background-image': 'url(/data/images/home_background/1.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
          <div class="animated-background height-50" :style="{'background-image': 'url(/data/images/home_background/2.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
        </div>
        <div class="hor-35">
          <div class="animated-background height-25" :style="{'background-image': 'url(/data/images/home_background/3.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
          <div class="animated-background height-25" :style="{'background-image': 'url(/data/images/home_background/4.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
          <div class="animated-background height-25" :style="{'background-image': 'url(/data/images/home_background/5.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
          <div class="animated-background height-25" :style="{'background-image': 'url(/data/images/home_background/6.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
        </div>
      </div>
      <div class="hor-half">
        <div class="hor-35">
          <div class="animated-background height-25" :style="{'background-image': 'url(/data/images/home_background/7.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
          <div class="animated-background height-25" :style="{'background-image': 'url(/data/images/home_background/8.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
          <div class="animated-background height-25" :style="{'background-image': 'url(/data/images/home_background/9.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
          <div class="animated-background height-25" :style="{'background-image': 'url(/data/images/home_background/12.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
        </div>
        <div class="hor-65">
          <div class="animated-background height-50" :style="{'background-image': 'url(/data/images/home_background/10.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
          <div class="animated-background height-50" :style="{'background-image': 'url(/data/images/home_background/11.jpg)'}">
            <img src="/spacer.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="background-image-mobile"></div>
    <div class="content-container">
      <h1>
        <span v-translate>WHICH</span> <b>
        <span v-translate>CELINE DION</span> </b>
        <span v-translate>ARE YOU?</span>
      </h1>
      <p v-if="connected === false">
        <span v-translate>Take the quiz to get a personalized playlist including tracks from Celine’s new album, Courage</span>
      </p>
      <p v-else>
      <span v-translate>Get your Celine Dion playlist by taking the quiz or discover a playlist tailored to your music library.</span>
      </p>
     <transition name="fade">
       <div v-if="connected === false">
         <!--
         <ul class="connect-toggle">
           <li class="spotify" v-bind:class="{active: musicService === 'Spotify'}" @click="musicService = 'Spotify'">
             <span class='rel'>
                <span><font-awesome-icon :icon="['fab', 'spotify']" /></span>
                <b>Spotify</b>
             </span>
           </li>
           <li class="apple"   v-bind:class="{active: musicService === 'Apple'}" @click="musicService = 'Apple'">
             <span class="rel">
               <span><font-awesome-icon :icon="['fab', 'apple']" /></span>
               <b>Apple Music</b>
             </span>
           </li>
         </ul>
        -->
         <div class="connection-button-container" v-if="musicService != null">
           <div class="connect-button spotify" ref="connect-button-spotify" v-if="musicService === 'Spotify'" @click="authSpotify(true)">
             <span class="icon"><font-awesome-icon :icon="['fab', 'spotify']" /></span>
             <span v-translate>Connect to Spotify</span>
           </div>

           <!--
           <div class="email-input-form" v-if="musicService === 'Apple'">
             <form class="" method="">
                <input type="text" v-model="userEmail" placeholder="Enter a valid email" v-bindv-bind:class="{error: isEmailValid === false}">
             </form>
           </div>

           <div class="connect-button apple" v-if="musicService === 'Apple'" @click="authApple()">
             <span><font-awesome-icon :icon="['fab', 'apple']" /></span>
             Connect To Apple
           </div>
          -->

           <p class="small">
             <input type="checkbox" id="terms"
             @change="onChange($event)"
              >
              <label v-translate for="terms">Subscribe to the Celine Dion newsletter. I understand that by checking this box and clicking CONNECT TO SPOTIFY, I agree to receive electronic messages from Sony Music Entertainment, Sony Music Entertainment Canada Inc., and its affiliates relating to Celine Dion.</label>
              <p class="tiny" v-translate>You may withdraw your consent to receive further electronic messages from Sony Music Entertainment, Sony Music Entertainment Canada Inc., and its affiliates at any time by using the unsubscribe link included in any such message.</p>
              <p class="tiny">Sony Music Entertainment, 25 Madison Avenue, New York, NY 10010 / <a href="https://www.sonymusic.com/feedback/">https://www.sonymusic.com/feedback/</a> </p>
              <p class="tiny">Sony Music Entertainment Canada Inc., 150 Ferrand Drive, Ste. 300 Toronto Ontario M3C 3E5 / newsletters@sonymusic.ca</p>
           </p>
         </div>
       </div>
       <div v-else>
         <ul class="connect-toggle user-choice">
           <li @click="startQuiz()">
             <span>
                <span v-translate>Take the quiz</span>
             </span>
           </li>
           <li @click="generatePlaylist()">
             <span>
                <span v-translate>Use library</span>
             </span>
           </li>
         </ul>
       </div>
     </transition>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/eventBus.js'
import { ae_redirect_url,
         ae_form_ID,
         ae_api_key,
         ae_api_key_enc,
         ae_spotify_auth_url,
         ae_brand_ID,
         ae_segment_ID,
         ae_default_mailinglist_ID
       }  from '@/meconfig.js';
import axios from 'axios';

export default {
  name: 'home',
  data: function () {
    return {
      connected: false,
      musicService: 'Spotify',
      interval: null,
      userEmail: null,
      isEmailValid: null,
      animatedBackgroundTimer: null,
      buttonDisabled: true,
      dataURLS: [
        '/data/images/home_background/1.jpg',
        '/data/images/home_background/2.jpg',
        '/data/images/home_background/3.jpg',
        '/data/images/home_background/4.jpg',
        '/data/images/home_background/5.jpg',
        '/data/images/home_background/6.jpg',
        '/data/images/home_background/7.jpg',
        '/data/images/home_background/8.jpg',
        '/data/images/home_background/9.jpg',
        '/data/images/home_background/10.jpg',
        '/data/images/home_background/11.jpg',
        '/data/images/home_background/12.jpg',
        '/data/images/home_background/13.jpg',
        '/data/images/home_background/14.jpg',
        '/data/images/home_background/15.jpg',
        '/data/images/home_background/16.jpg',
        '/data/images/home_background/17.jpg',
        '/data/images/home_background/18.jpg',
        '/data/images/home_background/19.jpg',
        '/data/images/home_background/20.jpg',
        '/data/images/home_background/21.jpg',
        '/data/images/home_background/22.jpg'
      ]
    }
  },
  mounted: function() {
    var self = this;

    // Give each background square image a random image
    self.createBackgroundImages();


    // Apple sends us an 'Authed' event if the user authenticates.
    document.addEventListener('authed', function (e) {
      self.appleAuthed();
      console.log('apple authed has been called');
    }, false);

    // The music player will tell us when window.userType has been set.
    // this is just an example implemetation of course
    EventBus.$on('connected', (type) => {
      self.connected = true;
    });

    EventBus.$on('connected', () => {

      var data = null;

      // If user opts in, subscribe them to the subs.sonymusic etc 
      if(localStorage.getItem('optIn') === 'yes'){
        data = {
          field_email_address: localStorage.getItem('userEmail'),
          ae: ae_api_key_enc,
          ae_member_id: window.aeID,
          ae_brand_id: ae_brand_ID,
          ae_segment_id: ae_segment_ID,
          ae_activities: '{"actions":{"presave":28591},"mailing_list_optins":{"a0S61000000b3FnEAI":28594}}',
          form: ae_form_ID,
          default_mailing_list: "a0S61000000b3FnEAI"
        };
      }else{
        data = {
          field_email_address: localStorage.getItem('userEmail'),
          ae: ae_api_key_enc,
          ae_member_id: window.aeID,
          ae_brand_id: ae_brand_ID,
          ae_segment_id: ae_segment_ID,
          ae_activities: '{"actions":{"presave":28591}',
          form: ae_form_ID,
        };
      }

      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://subs.sonymusicfans.com/submit', true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onload = function() {
        console.log(xhr.response);
      }
      xhr.onerror = function() {
        console.log('error');
      }
      var urlEncodedDataPairs = [];
      for(name in data) {
        urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
      }
      // Combine the pairs into a single string and replace all %-encoded spaces to
      // the '+' character; matches the behaviour of browser form submissions.
      var urlEncodedData = urlEncodedDataPairs.join('&').replace(/%20/g, '+');
      xhr.send(urlEncodedData);
        
      
      if(window.userType !== 'free'){
        self.createPremiumSpotify()
      }
    })

    //Generate the music service based on window.userType
    if(window.userType){
      console.log('we have a window user type it is ' + window.userType);
    }

    // Call the animation function.
    this.interval = window.setInterval(function(){
      self.animateBackgroundImage();
    }, 2000);

  },
  methods: {

    onChange($event){
      const checked = $event.target.checked
      if (checked){
        localStorage.setItem('optIn', 'yes');
        console.log('User has opted in');
      }else{
        localStorage.setItem('optIn', 'no');
        console.log('User has chosen not to opt in');
      }
    },


    // Direct the user to a playist
    generatePlaylist: function(){
      var routes = ['oohlala', 'bestie', 'fierce', 'lifeoftheparty', 'allthefeels'];
      var outcome = routes[Math.floor(Math.random()*routes.length)];
      this.$router.push({ name: 'result', params: {celineType: outcome} });
    },

    //-------------------------
    // CREATE THE BACKGROUNDS
    //-------------------------
    createBackgroundImages: function(){
      var self = this;
      var selectedDiv   = document.getElementsByClassName('animated-background');

      Array.prototype.forEach.call(selectedDiv, function(el) {
        var selectedImage = self.dataURLS[Math.floor(Math.random()* self.dataURLS.length)]
        el.style.backgroundImage = 'url('+ selectedImage +')';
      });
    },


    //-------------------------
    // IMAGE CHANGER
    //-------------------------
    animateBackgroundImage: function(){
      //select div
      var selectedDiv   = document.getElementsByClassName('animated-background');
      selectedDiv       = selectedDiv[Math.floor(Math.random()*selectedDiv.length)];
      //select image
      var selectedImage = this.dataURLS[Math.floor(Math.random()* this.dataURLS.length)]

      if(selectedDiv){
        selectedDiv.classList.add('fadeIn');

        self.animatedBackgroundTimer = setTimeout(function (){
          selectedDiv.style.backgroundImage = 'url('+ selectedImage +')';
          selectedDiv.classList.remove('fadeIn');
        }, 600);
      }
    },

    //-------------------------
    // APPLE AUTHENTICATION
    //-------------------------
    authApple: function() {
      if(this.checkEmail()){
       appleMusicKit.authorise(this.appleAuthCallback());
     }
    },

    checkEmail: function(){
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.isEmailValid = re.test(String(this.userEmail).toLowerCase());
      console.log(this.isEmailValid);
      return re.test(String(this.userEmail).toLowerCase());
    },

    // Apple auth callback
    appleAuthCallback: function(){
      this.musicService = 'Apple';
      var data = {
        // Email is mandatory. We send the email we collect before calling apple auth.
        field_email_address: this.userEmail,
        am_music_token: appleMusicKit.amkUserToken,

        ae: ae_api_key_enc,
        ae_member_id: "",
        ae_brand_id: ae_brand_ID,
        ae_segment_id: ae_segment_ID,
        ae_activities: '{"actions":{"presave":28595},"mailing_list_optins":{"a0S61000000b3FnEAI":28594}}',
        form: ae_form_ID,
        default_mailing_list: "a0S61000000b3FnEAI"
      };

      if ( typeof apple_token !== 'undefined' ) {
        // This is how SMF subs will be able to indicate the AM user to AE
        data.am_music_user_token = apple_music.musicUserToken;
      }

      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://subs.sonymusicfans.com/submit', true);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      xhr.onload = function() {
        console.log(xhr.response);
      }

      xhr.onerror = function() {
        console.log('error');
      }

      var urlEncodedDataPairs = [];

      for(name in data) {
        urlEncodedDataPairs.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
      }

      // Combine the pairs into a single string and replace all %-encoded spaces to
      // the '+' character; matches the behaviour of browser form submissions.
      var urlEncodedData = urlEncodedDataPairs.join('&').replace(/%20/g, '+');

      xhr.send(urlEncodedData);
      EventBus.$emit('connected')
    },

    //-------------------------
    // FREE USERS / ESCAPE HATCH
    //-------------------------
    authFreeUser: function(){
      window.userType = 'free';
    },


    authSpotify: function(isAE){
      if(isAE === true){
        console.log('This console log indicates that AE is being called to authenticate Spotify with AE');
        window.aeJS.trigger.authenticate('spotify', 'register', ae_redirect_url);
      }else{
        console.log('not using AE');
        this.spotifyAuth();
      }
    },

    //------------------
    // USER HAS BEEN AUTHED BY APPLE
    //------------------
    appleAuthed: function(){
      window.userType = 'Apple';
      EventBus.$emit('initMusicPlayer');
    },

    //------------------
    // CREATE MUSIC PLAYER
    //-------------------
    createPremiumSpotify(){
      window.token = window.spotifyAuthToken;
      var token    = window.token;
      window.player = new Spotify.Player({
        name: 'CELINE DION WEB PLAYER',
        getOAuthToken: cb => { cb(token); }
      });

      // Error handling
      window.player.on('initialization_error', e => console.error(e))
      window.player.on('authentication_error', e => console.error(e))
      window.player.on('account_error', e => console.error(e))
      window.player.on('playback_error', e => console.error(e))

      // Ready
      window.player.on('ready', data => {
        window.spotifyDeviceID = data.device_id;
        EventBus.$emit('initMusicPlayer');
      })

      window.player.addListener('player_state_changed', ({
        position,
        duration,
        track_window: { current_track }
      }) => {
        if (position + 500 >= duration){
          EventBus.$emit('playNext');
        }
      })

      // Not Ready -- if a device goes offline
      window.player.addListener('not_ready', ({ device_id }) => {
        console.log('spotify SDK player is NOT ready ')
      })

      window.player.connect()
    },

    //Redirect the user to the quiz.
    //Set a var on the window.
    startQuiz: function(){
      var self = this;
      clearInterval(this.interval);
      clearTimeout(this.animatedBackgroundTimer);
      window.quizStartd = true;
      console.log('we get here');
      this.$router.push({ name: 'Quiz' });
    },

  }
}
</script>


<!-- THIS STYLING NEEDS DELETING WHEN YOU BUILD -->
<style lang="scss">
  body {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
  }
  #app {
    box-sizing: border-box;
    background: #eee;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }


  //All pages wraped in this, to help transitions
  .body-container {
    display: flex;
    flex-grow: 1;
    width: 100%;
  }

  // HOME BACKGROUND IMAGE CONTAINER
  .background-image-container {
    position: fixed;
    left: 0;
    width: 100%;
    height: 100%;
    top: 0;
    z-index: 0;

    min-width: 1024px;
    min-height: 700px;

    img {
      width: 100%;
      height: auto;
      display: block;
      pointer-events: none;
      border-bottom: 10px solid #000;
    }

    .hor-half,
    .hor-65,
    .hor-35 {
      width: 50%;
      height: 100%;
      border: 6px solid #000;
      border-top: none;
      display: inline-block;
      border-bottom: none;
    }

    .hor-half:last-of-type {
      .hor-35 {
        border-left: 2px solid #000;
        border-right: none;
      }
    }

    .hor-65 {
      width: 65%;
    }
    .hor-35 {
      width: 35%;
      border-right: none;
      border-right: 2px solid #000;
    }

    .animated-background {
      width: 100%;
      height: auto;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      border-bottom: 10px solid #000;
      position: relative;

      &.height-33 {
        height: 33.3%;
        &:first-of-type {
          margin-top: -10%;
        }
      }
      &.height-25 {
        height: 25%;
      }
      &.height-50 {
        height: 50%;
      }

      img {
        opacity: 0;
      }

      &:after {
        content: '';
        background: #fff;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
        opacity: 0;
        transition: all 0.6s;
      }

      &.fadeIn:after {
        opacity: 1;
        transition: all 0.6s;
      }
    }

    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.65);
    }
  }

  .background-image-mobile {
    position: fixed;
    display: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    background-image: url('/data/images/approvedphotos/6.jpg');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
    &:after{
      content:'';
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: 0.8;
    }
  }

  // HOME CONTENT
  .content-container {
    display: block;
    position: relative;
    max-width: 640px;
    margin: 0 auto;
    color: #fff;
    z-index: 10;
  }

  .body-container.home {
    align-items: center;

    h1 {
      font-size: 3em;
      line-height: 1.2em;
      line-height: normal;
      cursor: default;
      margin: 0 0 20px 0;

      span {
        display: block;
        width: 100%;
        clear: both;
        text-align: center;
      }

      b {
        font-size: 1.2em;
      }
    }

    p {
      cursor: default;
      font-size: 1em;
      font-weight: 600;
      text-transform: uppercase;
      margin: 0 0 15px 0;
      font-size: 16px;
      line-height: 26px;
      padding: 0;
      &.tiny{
        font-size: 10px;
        text-transform: none;
        line-height: 1.2;
        margin: 10px 0;
        font-weight: normal;
        a{
          color: #fff;
        }
      }
    }


    .email-input-form {
      display: block;
      margin:  0 auto;
      padding: 0 10px;
      clear: both;
      width: 100%;
      max-width: 444px;
      overflow: hidden;
      background: #181818;

      form {
        display: block;
        margin: 0;
        padding: 0;
        height: auto;
        width: 100%;
      }

      input {
        background: #181818;
        width: 100%;
        color: #fff;
        display: block;
        margin: 10px auto 10px auto;
        height: 50px;
        border: none;
        outline: none;
        border-radius: 0;
        border-bottom: 1px solid #fff;
        line-height: 50px;
        font-size: 16px;
        padding: 0 10px;

        &:focus {
          outline: none;
        }

        &.error {
          border-bottom-color: red;
        }

        @media screen and (max-width: 800px){
          height: 30px;
          line-height: 30px;
          padding: 0 ;
        }
      }
    }

    //Home connection buttons
    .connect-toggle {
      display: inline-block;
      margin: 0 auto;
      border: 2px solid #fff;
      list-style: none;
      padding: 0;
      li {
        display: inline-block;
        padding: 0 30px;
        width: 220px;
        margin: 0;
        line-height: 50px;
        cursor: pointer;
        font-weight: 600;
        border-right: 1px solid #fff;
        transition: background 0.3s;

        span.rel {
          display: inline-block;
          position: relative;
          /*
          span {
            padding: 0;
            font-size: 25px;
            line-height: 48px;
            height: 50px;
            position: absolute;
            top: 0;
            left: 0;
            overflow: hidden;
            clear: both;
          }
          */
          span {
            display: inline-block;
            position: static;
            margin-right: 10px;
            position: relative;
            font-size: 23px;
            width: auto;
            top: 2px;
          }
          b {
            display: inline-block;

          }
        }

        &:hover,
        &.active {
          background: #fff;
          color: #000;
        }

        &:last-of-type {
          border-left: 1px solid #fff;
        }


        &.spotify {
          span {
            span {
              svg {
                width: 19px;
                top: 2px;
                position: relative;
              }
            }
          }
        }
      }

      &.user-choice {
        width: auto;
        border: none;
        li {
          border: 1px solid #fff;
          text-transform: uppercase;
          width: auto;
          color: #fff;
          a {
            color: #fff;
            text-decoration: none !important;
            &:hover{
              text-decoration: none;
              a{
                color: #000;
              }
            }
          }
          span {
            padding: 0;
            width: 100%;
            margin: 0;
            height: auto;
            display: block;
            font-size: 14px;
            position: static;
            @media screen and (max-width: 800px){
              line-height: 50px;
            }
          }
          &:hover{
            color: #000 !important;
            a{
              color: #000 !important;
            }
          }
        }
        li:first-of-type {
          float: left;
          margin-right: 20px;
        }
        li:last-of-type {
          margin-left: 20px;
          float: right;
        }
      }
    }
    .connection-button-container {
      display: block;
      width: 100%;
      height: auto;

      .connect-button {
        display: inline-block;
        margin: 20px auto;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        border-radius: 26px;
        cursor: pointer;
        padding: 0 10px 0 40px;
        font-weight: 400;
        width: 280px;
        position: relative;
        background: rgba(255,255,255,0.5);
        transition: all 0.3s;

        &.disabled{
          opacity: 0.5;
          cursor: initial;
          background: #1DB954 !important;
        }
        &.spotify {
          background: #1DB954;
          color: #fff;
          &:hover {
            background: #3dda75;
          }
        }
        &.apple {
          background: #181818;
          color: #fff;
          &:hover{
            background: #353535;
          }
        }

        span.icon {
          position: absolute;
          left: 0;
          font-size: 30px;
          top: 0;
          line-height: 52px;
          width: 50px;
        }
      }

      p.small {
        font-size: 12px;
        line-height: 22px;
        margin: 0;
        opacity: 0.8;
        text-transform: none;
      }
    }
  }

  @media screen and (max-width: 800px){
    .background-image-mobile {
      display: block;
    }
    .body-container.home {
      padding: 100px 0;
      .content-container {
        max-width: 90%;
        h1 {
          font-size: 34px;
        }
        p {
          padding: 0 10px;
          font-size: 12px;
        }

        .connection-button-container p.small {
          font-size: 10px;
          line-height: 20px;
        }
      }
      ul.connect-toggle {
        width: 100%;
        li {
          width: 50%;
          border: none;
          padding: 0;
          font-size: 12px;
          text-align: center;
          span {
            width: 100%;
            padding: 0;
          }
        }

        &.user-choice {
          li {
            display: inline-block;
            width: 100%;
            text-align: center;
            padding: 0;
            margin: 0 auto 30px auto;
          }
        }
      }
    }


    input[type=checkbox] + label:before  {
      width: 100px;
    }
    p.tiny {
      line-height: 22px;
    }
  }


  input[type=checkbox] + label {
    display: block;
    cursor: pointer;
  	display: flex;
    align-items: flex-start;
  	margin-right: 0.4em;
  }

  input[type=checkbox] {
    display: none;
  }

  input[type=checkbox] + label:before {
    content: "\2714";
    background-color: #fff;
  	border: 1px solid #181818;
    border-radius: 2px;
  	display: inline-block;
  	padding-left: 1px;
  	padding-bottom: 0px;
  	margin-right: 10px;
  	vertical-align: bottom;
  	color: transparent;
  	transition: .2s;
    width: 50px;
    height: 20px;
  }

  input[type=checkbox] + label:active:before {
    transform: scale(0);
  }

  input[type=checkbox]:checked + label:before {
    background-color: #181818;
    border-color: #181818;
    color: #fff;
  }

</style>
